import { tok, tokPx } from '@sunwebgroup/ui-components'
import { Icon, type IconGlyph, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

interface UserProfileFieldProps {
  icon: IconGlyph
  label: string
  value: string
}

const UserProfileFieldContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${tokPx('primitives_space_8')};
`
const UserProfileFieldLabel = styled(Typography)`
  color: ${tok('semantics_content_secondary_color')};
`

const UserProfileFieldIcon = styled(Icon)`
  flex-shrink: 0;
`

export function UserProfileField({ icon, label, value }: UserProfileFieldProps) {
  return (
    <UserProfileFieldContainer>
      <UserProfileFieldIcon glyph={icon} />
      <div>
        <UserProfileFieldLabel as="div" $variant="body-s-regular-tight">{label}</UserProfileFieldLabel>
        <Typography as="div" $variant="body-m-regular-tight">
          {value || '–'}
        </Typography>
      </div>
    </UserProfileFieldContainer>
  )
}
